import translate from '../../../utils/translations';

export const GOG_COPY_UPDATE_EXPERIMENT = 'vrbo_stx_gog_widget_copy_update';
export const INVITE_GUESTS_SENT = 'invite guests sent';
export const REMOVE_GUEST = 'removeGuest';
export const SEND_INVITE = 'sendInvite';
export const TRAVELLER_ACTIVITY = 'traveler activity';

export const getTranslatedLabels = ({translations, guestCount}) => ({
    ACCESS_TOOLTIP_BULLET1: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.tooltip.message1'
    ),
    ACCESS_TOOLTIP_BULLET2: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.tooltip.message2'
    ),
    ACCESS_TOOLTIP_BULLET3: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.tooltip.message3'
    ),
    ACCESS_TOOLTIP_TEXT_1: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'widget.trip.gog.copy.update.invite.tooltip.paragraph1'
    ),
    ACCESS_TOOLTIP_TEXT_2: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'widget.trip.gog.copy.update.invite.tooltip.paragraph2'
    ),
    ACCESS_TOOLTIP_TEXT_3: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.tooltip.title'
    ),
    ACCESS_WHAT_CAN_GUEST_SEE_TEXT: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.caption'
    ),
    ACCESS_WHAT_CAN_THEY_SEE_TEXT: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'widget.trip.gog.copy.update.postInvite.tooltip'
    ),
    ADD_CREW_HEADING: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.header'
    ),
    ADD_CREW_POST_INVITE_HEADING: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'widget.trip.gog.copy.update.postInvite.headline'
    ),
    ADD_GUEST_IMG_ALT: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.image.alt'
    ),
    ADD_GUESTS_LABEL: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests'
    ),
    ADD_GUEST_MODAL_SUB_HEADING: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.invite.guests.entry.subheading'
    ),
    ADD_GUEST_SUB_HEADING: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.addguests.info'
    ),
    ADD_GUESTS_TRIP_LABEL: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.header'
    ),
    EMAIL_REMOVE_LABEL: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.button.remove'
    ),
    EMAIL_SENT: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.toast.email.resend'
    ),
    ERROR_SOMETHING_WENT_WRONG: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.reply.error'
    ),
    EMAIL_TEXTBOX_LABEL: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.share.to'
    ),
    GUESTS_LABEL: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.propertySummary.guests'
    ),
    GUEST_VIEW_DETAILS: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.info'
    ),
    INVITE_CREW_LABEL: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests'
    ),
    INVITE_GUEST_MODAL_BUTTON_TEXT: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.button.invite.your.crew'
    ),
    INVITE_GUEST_MODAL_DESCRIPTION: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.entry.description'
    ),
    INVITE_GUEST_MODAL_MOBILE_TITLE: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.entry.mobile.heading'
    ),
    INVITE_GUEST_MODAL_NOTES: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.entry.note'
    ),
    INVITE_GUEST_MODAL_TITLE: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.entry.heading'
    ),
    INVITE_PEOPLE_LABEL: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.invite.guests.entry.heading'
    ),
    INVITE_SENT_LABEL: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'widget.trip.gog.copy.update.primary.btn'
    ),
    PEOPLE_LABEL: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.propertySummary.guests'
    ),
    SEND_INVITE_LABEL_COUNT: `${translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.button.send.invite'
    )} ${guestCount}`,
    WHOS_GOING_HEADING: translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.list'
    ),
});
